footer {
    max-width: 1600px;

    .row {
        display: grid;
        grid-template-columns: 1fr;
        @include mainPadding();

        @include breakpointMin('lg') {
            grid-template-columns: 1fr 1fr 1fr 1fr;
        }
    }

    .row-1 {
        background-color: var(--footer-background-color-row-1);

        @include breakpointMax('lg') {
            padding: 0px; // Reset mainPadding for accordion on mobile
        }

        @include breakpointMin('lg') {
            gap: 30px;
            padding-top: 60px;
            padding-bottom: 30px;
        }

    }

    .row-2 {
      background-color: var(--footer-background-color-row-2);
      padding-top: 15px;
      padding-bottom: 50px;
      gap: 30px;

      @include breakpointMin('lg') {
        gap: 30px;
        padding-top: 30px;
        padding-bottom: 50px;
      }
    }
}
